module.exports = __webpack_public_path__ + "static/media/Korean-sentence-structure-pattern.18d2fe74.PNG";